<!--
 * @Description: 
 * @Author: zhangben
 * @Date: 2024-08-06 08:55:58
 * @LastEditors: zhangben
 * @LastEditTime: 2024-12-03 13:06:08
-->
<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <div class="top">
      <div class="top_cen">
        <div class="logo">
          <a href="http://www.syybkj.cn/"
            ><img src="@/assets/images/logo.gif"
          /></a>
        </div>
        <div class="top_right">
          <div class="tel"><img src="@/assets/images/tel.gif" /></div>
          <div class="ser">
            <input
              v-model="keyword"
              name="name"
              type="text"
              class="wenben"
              id="name"
              placeholder="输入关键词"
            />
            <router-link :to="'/cooperation?title=' + keyword"
              ><a><input type="submit" value="" class="tijiao"/></a
            ></router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>400-114-1200
         
          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div> -->
    <!-- 电脑导航 -->
    <div class="header-nav container ">
      <!-- 导航logo -->
      <!-- <div class="header-nav-logo">
        <img src="@/assets/img/yctlogo.png" />
      </div> -->
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item, index) in navList"
          :key="index"
          @click="navClick(index, item.name)"
        >
          <router-link :to="item.path">
            {{ item.name }}
            <span
              v-if="item.children.length > 0"
              class="glyphicon glyphicon-menu-down"
            ></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length > 0">
            <dt v-for="(i, n) in item.children" :key="n">
              <router-link :to="i.path">{{ i.name }}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->

    <!-- 轮播图 -->
    <div id="swiper" class="container-fuild">
      <div class="swiper-container banner-swiper">
        <div class="swiper-wrapper">
          <div
            v-if="swiperList.length > 0"
            class="swiper-slide"
            v-for="(item, index) in swiperList"
            :key="index"
          >
            <img class="swiper-lazy" :data-src="item.pic" alt="轮播图" />
            <div class="swiper-lazy-preloader"></div>
            <!-- <div class="swiper-slide-title">
              <h1>{{ item.title }}</h1>
              <p>{{ item.content }}</p>
            </div> -->
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>

        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { queryBanner } from "@/api/api";
import Swiper from "swiper";
import { WOW } from "wowjs";

export default {
  name: "Header",
  data() {
    return {
      keyword: "",
      swiperList: [],
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "网站首页",
          path: "/",
          children: []
        },
        {
          name: "关于一博",
          path: "/software?pid=1",
          children: [
            {
              name: "公司简介",
              path: "/software?pid=1"
            },
            {
              name: "组织架构",
              path: "/software?pid=2"
            },
            {
              name: "文化理念",
              path: "/software?pid=3"
            },
            {
              name: "企业风采",
              path: "/software?pid=4"
            },
            {
              name: "老总致辞",
              path: "/software?pid=5"
            }
          ]
        },
        {
          name: "资质荣誉",
          path: "/service?pid=13",
          children: []
        },
        {
          name: "咨询服务",
          path: "/serviceCenter?pid=1",
          children: [
            {
              name: "医疗器械经营",
              path: "/serviceCenter?pid=1"
            },
            {
              name: "医疗器械生产注册",
              path: "/serviceCenter?pid=2"
            },
            {
              name: "药品经营",
              path: "/serviceCenter?pid=10"
            },
            {
              name: "食品生产经营",
              path: "/serviceCenter?pid=11"
            },
            {
              name: "工商注册",
              path: "/serviceCenter?pid=12"
            },
            {
              name: "冷链验证",
              path: "/serviceCenter?pid=13"
            }
          ]
        },
        {
          name: "产品中心",
          path: "/healthScience?pid=1",
          children: [
            {
              name: "冷库建设",
              path: "/healthScience?pid=1"
            },
            {
              name: "产品展示",
              path: "/healthScience?pid=2"
            }
          ]
        },
        {
          name: "新闻资讯",
          path: "/cooperation?pid=1",
          children: [
            {
              name: "公告通知",
              path: "/cooperation?pid=1"
            },
            {
              name: "公司新闻",
              path: "/cooperation?pid=2"
            },
            {
              name: "行业动态",
              path: "/cooperation?pid=10"
            },
            {
              name: "政策法规",
              path: "/cooperation?pid=11"
            }
          ]
        },
        {
          name: "成功案例",
          path: "/gcal?pid=1",
          children: []
        },
        {
          name: "人力资源",
          path: "/recruitment",
          children: [
            {
              name: "在线招聘",
              path: "/recruitment?pid=1"
            },
            {
              name: "用人理念",
              path: "/recruitment?pid=10"
            }
          ]
        },
        {
          name: "数据查询",
          path: "/data",
          children: []
        },
        {
          name: "联系我们",
          path: "/contactus?pid=12",
          children: []
        }
      ]
    };
  },
  mounted() {
    // if()
    queryBanner().then(res => {
      // this.navList = res.data.data;
      this.swiperList = res.data.data;
      // console.log(res.data.data);
      // sessionStorage.setItem("navAllList", JSON.stringify(this.navList));
    });
    // console.log("//////");

    /* banner-swiper */
    new Swiper(".banner-swiper", {
      loop: true, // 循环模式选项
      effect: "fade",
      //自动播放
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      // 延迟加载
      lazy: {
        loadPrevNext: true
      },
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true //修改swiper的父元素时，自动初始化swiper
    });
    // new Swiper(".swiper-container", {
    //   loop: true, // 循环模式选项
    //   slidesPerView: 3,
    //   //自动播放
    //   autoplay: {
    //     delay: 3000,
    //     stopOnLastSlide: false,
    //     disableOnInteraction: false
    //   },
    //   // 如果需要前进后退按钮
    //   navigation: {
    //     nextEl: ".swiper-button-next",
    //     prevEl: ".swiper-button-prev"
    //   },
    //   observer: true, //修改swiper自己或子元素时，自动初始化swiper
    //   observeParents: true //修改swiper的父元素时，自动初始化swiper
    // });
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true
    });
    wow.init();
    // console.log(this.navIndex);
    // console.log(sessionStorage.getItem("navIndex"));
  },
  methods: {
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      console.log(this.navIndex, "12---->>>>>");
      sessionStorage.setItem(
        "menueIndex",
        JSON.stringify(this.navList[index].children)
      );
      this.menuName = name;
    },
    initIndex(index) {
      this.navIndex = index;
      console.log(this.navIndex, "12---->>>>>");
      sessionStorage.setItem("navIndex", index);
      sessionStorage.setItem(
        "menueIndex",
        JSON.stringify(this.navList[index].children)
      );
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    }
  }
};
</script>
<style scoped>
/* 轮播图 */
/* #swiper {
  height: 600px;
} */
#swiper .banner-swiper {
  width: 100%;
  height: 100%;
}
#swiper .banner-swiper .swiper-slide img {
  width: 100%;
  height: 100%;
}
#swiper .banner-swiper .swiper-slide {
  position: relative;
}
#swiper .banner-swiper .swiper-slide-title {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999999999;
  width: 100%;
  height: 100%;
  color: #fff;
  background: rgba(51, 51, 51, 0.534);
  text-align: center;
  line-height: 80px;
}
#swiper .banner-swiper .swiper-slide-title > h1 {
  font-size: 50px;
  margin-top: 12%;
}
#swiper .banner-swiper .swiper-slide-title > p {
  font-size: 20px;
  margin-top: 1%;
  font-weight: 700;
}
/* 顶部 */
#header {
  /* z-index: 100;
  position: fixed; */
  width: 100%;
  /* background: #f4f4f4;
  transition: all ease 0.6s; */
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #009d91;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  /* height: 110px; */
  width: 100%;
  height: 69px;
  float: left;
  background: url(../assets/images/meu.gif) repeat-x;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 100px;
  height: 100%;
  float: left;
  position: relative;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 95px;
  height: 45px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 50px;
  /* float: right; */
  margin: 0 auto;
  max-width: 1200px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  /* margin: 0 15px; */
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  display: block;
  cursor: pointer;
  padding: 0px;
  color: #fff;
  text-decoration: none;
  font-family: "微软雅黑";
  font-weight: bold;
  font-size: 14px;
  line-height: 44px;
  width: 120px;
  height: 44px;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  /* display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #009d91; */
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #005bbf;
  background: url(../assets/images/meu_hover.gif) no-repeat bottom center;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #005bbf;
  background: url(../assets/images/meu_hover.gif) no-repeat bottom center;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  /* width: 168px; */
  /* top: 80%; */
  left: 0;
  z-index: 999999;
  /* box-shadow: 0 0 3px 1px #ccc; */
  /* color: #fff;
  background: #009d91; */
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  float: left;
  width: 100px;
  height: 25px;
  line-height: 25px;
  font-size: 12px;
  color: #0348a1;
}
#header .header-nav .header-nav-wrapper > li > dl > dt > a {
  color: #0348a1;
}
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  color: #005bbf;
  background: url(../assets/images/meu_hover.gif) no-repeat bottom center;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  color: #005bbf;
  a {
    color: #005bbf;
    text-decoration: none;
  }
}
#header .header-nav .header-nav-wrapper > li > dl:hover {
  color: #005bbf;
}
/* a {
    color: #337ab7;
    text-decoration: none;
} */
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  color: #005bbf;
  background: url(../assets/images/meu_hover.gif) no-repeat bottom center;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: flex;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  color: #005bbf;
  background: url(../assets/images/meu_hover.gif) no-repeat bottom center;
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #009d91;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #000;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
*/ .logo {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue